import React from 'react';
import { useState, useEffect } from 'react';
import customHeaders, { getSpace } from '../../../../../common/headers';
import useGeneralStore from '../../../../../store/general';
import { ButtonClose, InputDinamycPlaceholder, DropDownSelector, Checkbox } from "@lk-gtcom/ecomlab-components";
import { TitlePage } from '../../../../../components/TitlePage/TitlePage';
import { DynamicFormComponent } from '../../../../../components/DynamicFormComponent/DynamicFormComponent';
import './ModalAddCustomServicesCRM.scss'

const option_payment_type = [
    {
        label: 'фиксированная',
        value: 'фиксированная',
    },
    {
        label: 'расчетная',
        value: 'расчетная',
    }
];

const option_payment_part = [
    {
        label: 'предоплата',
        value: 'предоплата',
    },
    {
        label: 'постоплата',
        value: 'постоплата',
    }
];

const option_payment_period = [
    {
        label: 'разовая',
        value: 'разовая',
    },
    {
        label: 'ежемесячная',
        value: 'ежемесячная',
    }
];

interface CurrentCustomService {
    name?: string;
    unit?: string;
    price_unit?: string;
    amount_unit?: string;
    active?: boolean;
    need_report?: boolean;
    payment_part?: string;
    payment_type?: string;
    payment_period?: string;
    comment?: string;
    invoice_name?: string;
    additional_fields?: any[];
    id?: number;
    record_id?: number;
}


interface ModalAddServicesCRMProps {
    setIsModal: (e: boolean) => void
    currentCustomService?: null | CurrentCustomService
    setCurrentCustomService?: (e: number | null) => void
    currentDeal?: number | string | null
    setCurrentDeal?: (e: number | string | null) => void
}

const ModalAddCustomServicesCRM = ({
    setIsModal,
    currentCustomService,
    setCurrentCustomService,
    currentDeal,
    setCurrentDeal
}: ModalAddServicesCRMProps) => {
    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };

    const [idServices, setIdServices] = useState(null)
    const [name, setName] = useState(currentCustomService?.name || '')
    const [legalName, setLegalName] = useState(currentCustomService?.invoice_name || '')
    const [unit, setUnit] = useState(currentCustomService?.unit || '')
    const [price, setPrice] = useState(currentCustomService?.price_unit || '')
    const [amountUnit, setAmountUnit] = useState(currentCustomService?.unit || '')
    const [active, setActive] = useState(currentCustomService?.active)
    const [needReport, setNeedReport] = useState(currentCustomService?.need_report)
    const [comment, setComment] = useState(currentCustomService?.comment || '')

    const current_payment_type = option_payment_type.filter((el) => el?.label == currentCustomService?.payment_type)?.[0]
    const current_payment_part = option_payment_part.filter((el) => el?.label == currentCustomService?.payment_part)?.[0]
    const current_payment_period = option_payment_period.filter((el) => el?.label == currentCustomService?.payment_period)?.[0]

    const [selectedPaymentType, setSelectedPaymentType] = useState(current_payment_type)
    const [selectedPaymentPart, setSelectedPaymentPart] = useState(current_payment_part)
    const [selectedPaymentPeriod, setSelectedPaymentPeriod] = useState(current_payment_period)

    const [contacts, setContacts] = useState([])
    const [isModalContactCRM, setIsModalContactCRM] = useState(false)
    const [isModalFields, setIsModalFields] = useState(false)

    const [contactList, setContactList] = useState([])
    const [contactPage, setContactPage] = useState(1);
    const [contactQuery, setContactQuery] = useState('');
    const [selectedContact, setSelectedContact] = useState(null)

    const currentId = idServices ? idServices : currentCustomService
    const [fields, setFilds] = useState(
        currentCustomService?.additional_fields?.length > 0 ?
            currentCustomService?.additional_fields?.map(({ name, id, type, value, possible_values }) => ({ front_name: name, data_type: type, id: id, value: value ? JSON?.parse(value) : null, possible_values: possible_values }))
            : []
    );

    const [load, setLoad] = useState(false)

    const currentContactList = contactList?.map(({ id, name }) => ({ label: name, value: id }))


    // Удаление услуги
    const fetchDeleteServices = () => {
        let url = ` https://portals.ecomru.ru/api/crm/services/${currentId}`

        fetch(url, { method: 'DELETE', headers })
            .then((res) => res.json())
            .then((json) => {
                setIdServices(json)
            })
            .catch((err) => console.error(err));
    };

    // Добавить название компании
    const fetchSetName = () => {
        let url = ` https://portals.ecomru.ru/api/crm/services/custom/name`

        const body = JSON.stringify({
            record_id: currentCustomService?.record_id,
            name
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log(`name changed`)
            })
            .catch((err) => console.error(err));
    };

    // Добавить юридическое название
    const fetchSetLegalName = () => {
        let url = ` https://portals.ecomru.ru/api/crm/services/custom/invoice_name`

        const body = JSON.stringify({
            record_id: currentCustomService?.record_id,
            invoice_name: legalName
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log(`number changed`)
            })
            .catch((err) => console.error(err));
    };

    // Добавить ед измерения
    const fetchSetUnit = () => {
        let url = ` https://portals.ecomru.ru/api/crm/services/custom/unit`

        const body = JSON.stringify({
            record_id: currentCustomService?.record_id,
            unit: unit
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log(`name changed`)
            })
            .catch((err) => console.error(err));
    };

    // Добавить цену
    const fetchSetPrice = () => {
        let url = ` https://portals.ecomru.ru/api/crm/services/custom/price_unit`

        const body = JSON.stringify({
            record_id: currentCustomService?.record_id,
            price_unit: price
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log(`name changed`)
            })
            .catch((err) => console.error(err));
    };

    // Добавить всего
    const fetchSetAmountUnit = () => {
        let url = ` https://portals.ecomru.ru/api/crm/services/custom/amount_unit`

        const body = JSON.stringify({
            record_id: currentCustomService?.record_id,
            amount_unit: amountUnit
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log(`name changed`)
            })
            .catch((err) => console.error(err));
    };

    // Добавить способ оплаты
    const fetchSetPaymenPart = () => {
        let url = ` https://portals.ecomru.ru/api/crm/services/custom/payment_part`

        const body = JSON.stringify({
            record_id: currentCustomService?.record_id,
            payment_part: selectedPaymentPart?.value
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log(`name changed`)
            })
            .catch((err) => console.error(err));
    };

    // Добавить период оплаты
    const fetchSetPaymenPeriod = () => {
        let url = ` https://portals.ecomru.ru/api/crm/services/custom/payment_period`

        const body = JSON.stringify({
            record_id: currentCustomService?.record_id,
            payment_period: selectedPaymentPeriod?.value
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log(`name changed`)
            })
            .catch((err) => console.error(err));
    };

    // Добавить комментарий
    const fetchSetComment = () => {
        let url = ` https://portals.ecomru.ru/api/crm/services/custom/comment`

        const body = JSON.stringify({
            record_id: currentCustomService?.record_id,
            comment: comment
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log(`number changed`)
            })
            .catch((err) => console.error(err));
    };

    // Добавить тип оплаты
    const fetchSetPaymentType = () => {
        let url = ` https://portals.ecomru.ru/api/crm/services/custom/payment_type`

        const body = JSON.stringify({
            record_id: currentCustomService?.record_id,
            payment_type: selectedPaymentType?.value
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log(`name changed`)
            })
            .catch((err) => console.error(err));
    };

    // Добавить active
    const fetchSetActive = (active: boolean) => {
        let url = ` https://portals.ecomru.ru/api/crm/services/custom/active`

        const body = JSON.stringify({
            record_id: currentCustomService?.record_id,
            active
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log(`email changed`)
            })
            .catch((err) => console.error(err));
    };

    // Добавить телефон компании
    const fetchSetNeedReport = (need_report: boolean) => {
        let url = ` https://portals.ecomru.ru/api/crm/services/custom/need_report`

        const body = JSON.stringify({
            record_id: currentCustomService?.record_id,
            need_report
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log(`phone changed`)
            })
            .catch((err) => console.error(err));
    };

    // Получение контактов по компании
    const fetchGetContact = (id: number | string): void => {

        if (!id) return
        let url = ` https://portals.ecomru.ru/api/crm/companies/${id}/contacts?can_be_add=false`

        fetch(url, { method: 'GET', headers })
            .then((res) => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error(res.json() as any);
                }
            })
            .then((json) => {
                setContacts(json)
                const selected_contacts = json?.map(({ id, name, phone, email, address }) => ({
                    label: name,
                    value: id,
                    phone, email, address
                }))
                setSelectedContact(selected_contacts)
            })
            .catch((err) => {
                console.error(err);
            });
    };

    // Получение контактов к добавлению
    const fetchGetContactList = () => {
        let url = ` https://portals.ecomru.ru/api/crm/contacts/?page=${contactPage}&limit=50&search=${contactQuery}`

        fetch(url, { method: 'GET', headers })
            .then((res) => res.json())
            .then((json) => {
                const { data, total } = json
                if (contactPage > 1) {
                    setContactList((prev) => [...prev, ...data]);
                } else {
                    setContactList([...data]);
                }
            })
            .catch((err) => console.error(err));
    };

    useEffect(() => {
        fetchGetContactList();
    }, [contactPage, contactQuery]);

    // Получение доп полей компании
    const fetchGetFieldsList = (id: number | string): void => {
        let url = ` https://portals.ecomru.ru/api/crm/services/additional_fields/${currentCustomService?.record_id}`

        fetch(url, { method: 'GET', headers })
            .then((res) => res.json())
            .then((json) => {
                if (Array.isArray(json)) {
                    setFilds(json?.map(({ name, id, type, value, possible_values }) => ({ front_name: name, data_type: type, id: id, value: value ? JSON?.parse(value) : null, possible_values: possible_values })))
                }
            })
            .catch((err) => console.error(err));
    };

    // Запись полей
    const fetchSetValueField = (id: number | string, value: any): void => {
        let url = ` https://portals.ecomru.ru/api/crm/services/custom/additional_field`

        const body = JSON.stringify({
            field_id: id,
            record_id: currentCustomService?.record_id,
            new_value: (value !== null || value !== undefined) ? JSON?.stringify(value) : null
        })

        fetch(url, { method: 'PATCH', headers, body })
            .then((res) => res.json())
            .then((json) => {
                // if (Array.isArray(json)) {
                //     setFilds(json)
                // }
            })
            .catch((err) => console.error(err));
    };


    useEffect(() => {
        if (currentId && !isModalContactCRM) {
            fetchGetContact(currentId)
            fetchGetFieldsList(currentId)
        }
    }, [currentId, isModalContactCRM]);

    const onClose = () => {
        if (!name) {
            fetchDeleteServices()
        }
        setCurrentCustomService(null)
        // setCurrentDeal(null)
        setIsModal(false)
    }

    return (
        <>
            {/* {isModalContactCRM && <ModalAddContactCRM
                currentServices={currentServices}
                isModal={false}
                setIsModal={setIsModalContactCRM}
            />} */}

            {/* {isModalFields && <ModalAddFields
                setIsModal={setIsModalFields}
            />} */}

            <div
                className='blackout'
                style={{ zIndex: 12 }}
                onClick={(e) => {
                    e.stopPropagation()
                    let el = e.target as HTMLElement
                    if (el.classList.contains('blackout')) {
                        onClose()
                    }
                }}
            >
                <div className='modal-add-services-custom-CRM'>
                    <div className='modal-add-services-custom-CRM__header'>
                        <TitlePage
                            title={'Редактирование услуги внутри договора'}
                        />

                        <ButtonClose
                            onClick={(e: Event) => {
                                onClose()
                            }}
                        />
                    </div>

                    <div className='modal-add-services-custom-CRM__main-content'>

                        <TitlePage
                            medium
                            title={'Основная информация'}
                        />

                        <div className='modal-add-services-custom-CRM__content'>
                            <InputDinamycPlaceholder
                                placeholder='Название услуги'
                                onChange={(e) => setName(e)}
                                changeValue={name}
                                onBlur={fetchSetName}
                                size='s'
                                required
                            />

                            <InputDinamycPlaceholder
                                placeholder='Название счета'
                                onChange={(e) => setLegalName(e)}
                                changeValue={legalName}
                                onBlur={fetchSetLegalName}
                                size='s'
                            />

                            <InputDinamycPlaceholder
                                placeholder='Единица измерения'
                                onChange={(e) => setUnit(e)}
                                changeValue={unit}
                                onBlur={fetchSetUnit}
                                size='s'
                            />

                            <InputDinamycPlaceholder
                                placeholder='Цена за единицу'
                                onChange={(e) => setPrice(e)}
                                changeValue={price}
                                onBlur={fetchSetPrice}
                                size='s'
                            />

                            <InputDinamycPlaceholder
                                placeholder='Всего единиц'
                                onChange={(e) => setAmountUnit(e)}
                                changeValue={amountUnit}
                                onBlur={fetchSetAmountUnit}
                                size='s'
                            />

                            <DropDownSelector
                                isClearable={false}
                                state={selectedPaymentType}
                                options_prop={option_payment_type}
                                setState={(e) => setSelectedPaymentType(e)}
                                placeholder='Тип оплаты'
                                maxWidth='100%'
                                width='100%'
                                onBlur={() => fetchSetPaymentType()}
                            />

                            <DropDownSelector
                                isClearable={false}
                                state={selectedPaymentPart}
                                options_prop={option_payment_part}
                                setState={(e) => setSelectedPaymentPart(e)}
                                placeholder='Способ оплаты'
                                maxWidth='100%'
                                width='100%'
                                onBlur={() => fetchSetPaymenPart()}
                            />

                            <DropDownSelector
                                isClearable={false}
                                state={selectedPaymentPeriod}
                                options_prop={option_payment_period}
                                setState={(e) => setSelectedPaymentPeriod(e)}
                                placeholder='Период оплаты'
                                maxWidth='100%'
                                width='100%'
                                onBlur={() => fetchSetPaymenPeriod()}
                            />

                            {/* <TextareaDynamicPlaceholder
                                placeholder='Комментарии'
                                onChange={(e) => setComment(e)}
                                changeValue={comment}
                                onBlur={fetchSetComment}
                                size='s'
                                width='100%'
                            /> */}

                            <Checkbox
                                value={active}
                                onChange={(checked) => {
                                    setActive(checked)
                                    fetchSetActive(checked)
                                }}
                            >Активно</Checkbox>

                            <Checkbox
                                value={needReport}
                                onChange={(checked) => {
                                    setNeedReport(checked)
                                    fetchSetNeedReport(checked)
                                }}
                            >Требуется отчет</Checkbox>
                        </div>

                        <TitlePage
                            medium
                            title={'Дополнительные поля'}
                        />

                        <div className='modal-add-services-custom-CRM__content'>
                            <DynamicFormComponent
                                productTemporary={fields}
                                fetchSetValue={fetchSetValueField as any}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export { ModalAddCustomServicesCRM }